import React from 'react';
import { Star, Trophy, Flame, Crown, ArrowLeft } from 'lucide-react';
import { HomeMenuProps } from '../types';

const HomeMenu = ({ onSelect, gameState, hasPreloadedVocab }: HomeMenuProps) => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-6 space-y-8 animate-fade-in">
      <div className="text-center space-y-4">
        <div className="text-8xl animate-bounce-short filter drop-shadow-lg">🦁</div>
        <h2 className="text-2xl text-sky-700 font-bold animate-pulse">Hello! Let's learn English!</h2>
        <p className="text-gray-600">你好！让我们一起学英语吧！</p>

        {/* Game Stats Display */}
        <div className="flex justify-center space-x-4 mt-4">
          <div className="bg-gradient-to-r from-purple-400 to-purple-600 text-white px-4 py-2 rounded-full shadow-lg animate-pulse">
            <div className="flex items-center space-x-2">
              <Crown className="w-5 h-5" />
              <span className="font-bold">Level {gameState.level}</span>
            </div>
          </div>
          <div className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-white px-4 py-2 rounded-full shadow-lg animate-pulse">
            <div className="flex items-center space-x-2">
              <Star className="w-5 h-5 fill-white" />
              <span className="font-bold">{gameState.totalScore} pts</span>
            </div>
          </div>
          <div className="bg-gradient-to-r from-orange-400 to-orange-600 text-white px-4 py-2 rounded-full shadow-lg animate-pulse">
            <div className="flex items-center space-x-2">
              <Flame className="w-5 h-5" />
              <span className="font-bold">{gameState.streak} 🔥</span>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full space-y-4">
        <button
          onClick={() => onSelect('vocab')}
          className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-yellow-900 p-6 rounded-2xl shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center space-x-4 border-b-4 border-yellow-600 hover:border-yellow-700 relative overflow-hidden group"
        >
          {/* Preloaded indicator */}
          {hasPreloadedVocab && (
            <div className="absolute top-2 right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full animate-pulse font-bold flex items-center">
              <span className="w-2 h-2 bg-white rounded-full mr-1 animate-ping"></span>
              READY
            </div>
          )}
          <div className="absolute inset-0 bg-white/20 transform translate-y-full group-hover:translate-y-0 transition-transform duration-200"></div>
          <div className="bg-white p-3 rounded-full shadow-sm text-2xl z-10">🎮</div>
          <div className="text-left z-10">
            <div className="font-bold text-xl">Word Challenge</div>
            <div className="text-sm opacity-80">单词大挑战</div>
            <div className="text-xs opacity-60 mt-1">🎯 Win coins & trophies!{hasPreloadedVocab && " ⚡ Instant start!"}</div>
          </div>
        </button>

        <button
          onClick={() => onSelect('chat')}
          className="w-full bg-gradient-to-r from-green-400 to-emerald-500 hover:from-green-500 hover:to-emerald-600 text-green-900 p-6 rounded-2xl shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center space-x-4 border-b-4 border-green-600 hover:border-green-700 relative overflow-hidden group"
        >
          <div className="absolute inset-0 bg-white/20 transform translate-y-full group-hover:translate-y-0 transition-transform duration-200"></div>
          <div className="bg-white p-3 rounded-full shadow-sm text-2xl z-10">🐼</div>
          <div className="text-left z-10">
            <div className="font-bold text-xl">Panda Chat</div>
            <div className="text-sm opacity-80">熊猫外教陪练</div>
            <div className="text-xs opacity-60 mt-1">💬 Chat & learn!</div>
          </div>
        </button>
      </div>

      {/* Achievements Display */}
      {gameState.achievements.length > 0 && (
        <div className="w-full mt-4">
          <h3 className="text-center font-bold text-gray-700 mb-2">🏆 Recent Achievements</h3>
          <div className="flex justify-center space-x-2 flex-wrap">
            {gameState.achievements.slice(-3).map((achievement, index) => (
              <div key={index} className="bg-gradient-to-r from-purple-100 to-pink-100 px-3 py-1 rounded-full text-xs font-medium text-purple-700 border border-purple-300 animate-pulse">
                {achievement}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeMenu;